export const asideStepperStyle = {
	wrapper: {
		position: 'relative',
		borderRadius: '12px',
		backgroundColor: 'var(--primary-500)',
		padding: {
			xs: '12px',
			sm: '40px',
		},
		overflow: 'hidden',

		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		minHeight: {
			xs: 'auto',
			lg: 'calc(100vh - 80px)',
		},
	},

	logo: {
		marginBottom: '80px',
	},

	title: {
		textTransform: 'capitalize',
		color: 'var(--default-white)',
		fontSize: '34px',
		fontWeight: 700,
		marginBottom: '60px',
	},

	link: {
		fontSize: '14px',
		fontWeight: 400,
		color: 'var(--default-white)',
		textDecoration: 'none',
	},

	footer: {
		display: 'flex',
		gap: {
			xs: '10px',
			md: '40px',
		},
		position: 'absolute',
		bottom: '40px',

		'& a:hover': {
			opacity: '0.7',
		},
	},
};
